import React, { Component } from 'react';
import {
  string,
  func,
  bool,
  shape,
} from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import TextBox from '../form/TextBox';
import Password from '../form/PasswordContainer';
import { required } from '../form/validators';

// eslint-disable-next-line react/prefer-stateless-function
class LogInForm extends Component {
  render() {
    const {
      forgotPasswordPath,
      handleSubmit,
      serverMessage,
      signUp,
      initialValues,
    } = this.props;
    const disabled = this.props.isSubmitting ? { disabled: 'disabled' } : {};

    return (
      <div className="mh1 mh2-m mh3-l mv3">
        <form onSubmit={handleSubmit}>
          <div>
            {initialValues['login-email'] && (
              <div className="f6 mb2">
                <span className="dark-gray">Email: </span>
                <span>{initialValues['login-email']}</span>
              </div>
            )}
            <div className="fl w-100">
              <Field
                name="login-email"
                label={!initialValues['login-email'] ? 'Enter your email' : ''}
                dataTestId="my-account-login-email"
                component={TextBox}
                validate={[required]}
                type={initialValues['login-email'] ? 'hidden' : 'text'}
                readOnly={initialValues && !!initialValues['login-email']}
                style={this.props.emailInputStyles}
              />
            </div>
            <div className="fl w-100">
              <Field
                name="login-password"
                label="Password"
                dataTestId="my-account-login-password"
                component={Password}
                validate={[required]}
                type="password"
                selectorName="login"
                forgotPasswordPath={forgotPasswordPath}
              />
            </div>
          </div>
          {
            serverMessage &&
            (
              <div className="fl w-100 ph2">
                <div className="flex items-center mt2 mb3">
                  <span style={{ color: 'red' }}>
                    {serverMessage}
                  </span>
                </div>
              </div>
            )
          }
          <button
            type="submit"
            data-test-id="my-account-login-button"
            className="gcc-btn gcc-btn-primary flex justify-center items-center w-100 pa3 bw0 white mv3 f4"
            {...disabled}
          >
            {
              this.props.isSubmitting &&
              <div className="relative">
                <div className="gcc-loading h2 w2 nl5 nt3 absolute left-1">
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                  <div className="w-100 h-100 absolute left-0 top-0" />
                </div>
              </div>
            }
            <div>Login to My Account</div>
          </button>
          <div className="fl w-100 tc">
            {
              this.props.displayRegisterLink &&
              (<p className="f6">Don&rsquo;t have an account? <span data-test-id="my-account-register-text-link" role="button" tabIndex={-3} className="blue pointer" onClick={signUp}>Create one now</span>.</p>)
            }
            {
              this.props.displaySitePolicyLinks &&
              (
                <p className="f7">
                  <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
                  <span className="dib mh2">|</span>
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </p>
              )
            }
          </div>
        </form>
      </div>
    );
  }
}

LogInForm.defaultProps = {
  forgotPasswordPath: '',
  isSubmitting: false,
  initialValues: {},
  displayRegisterLink: true,
  displaySitePolicyLinks: true,
  emailInputStyles: undefined,
};

LogInForm.propTypes = {
  forgotPasswordPath: string,
  handleSubmit: func.isRequired,
  isSubmitting: bool,
  serverMessage: string.isRequired,
  signUp: func.isRequired,
  initialValues: shape({
    'login-email': string,
  }),
  displayRegisterLink: bool,
  displaySitePolicyLinks: bool,
  emailInputStyles: shape({}),
};

export default reduxForm({
  form: 'login',
})(LogInForm);
